import { getEntityPluralLabel } from "../entity-labels";

import { EntityType } from "@/queries";

export interface TypeOption {
  value: EntityType;
  label: string;
  color: string;
}

export interface PeopleOption {
  value: string;
  label: string;
}

export const typeOptions: TypeOption[] = [
  {
    value: EntityType.FOLDER,
    label: getEntityPluralLabel(EntityType.FOLDER),
    color: "",
  },
  {
    value: EntityType.PROMPT,
    label: getEntityPluralLabel(EntityType.PROMPT),
    color: "",
  },
  {
    value: EntityType.WORKFLOW,
    label: getEntityPluralLabel(EntityType.WORKFLOW),
    color: "",
  },
  {
    value: EntityType.DATASET,
    label: getEntityPluralLabel(EntityType.DATASET),
    color: "",
  },
  {
    value: EntityType.INPUT_VARIABLE_SET,
    label: getEntityPluralLabel(EntityType.INPUT_VARIABLE_SET),
    color: "",
  },
  {
    value: EntityType.REPORT,
    label: getEntityPluralLabel(EntityType.REPORT),
    color: "",
  },
  {
    value: EntityType.AB_TEST,
    label: getEntityPluralLabel(EntityType.AB_TEST),
    color: "",
  },
  {
    value: EntityType.SNIPPET,
    label: getEntityPluralLabel(EntityType.SNIPPET),
    color: "",
  },
  {
    value: EntityType.SKILL_COLLECTION,
    label: getEntityPluralLabel(EntityType.SKILL_COLLECTION),
    color: "",
  },
  {
    value: EntityType.SMART_TABLE,
    label: getEntityPluralLabel(EntityType.SMART_TABLE),
    color: "",
  },
  {
    value: EntityType.TOOL,
    label: getEntityPluralLabel(EntityType.TOOL),
    color: "",
  },
];

export const peopleOptions: PeopleOption[] = [
  { value: "john_doe", label: "John Doe" },
  { value: "jane_smith", label: "Jane Smith" },
  { value: "mike_johnson", label: "Mike Johnson" },
  { value: "sarah_wilson", label: "Sarah Wilson" },
];

export const getTypeOption = (value: EntityType): TypeOption | undefined =>
  typeOptions.find(option => option.value === value);

export const getPeopleOption = (value: string): PeopleOption | undefined =>
  peopleOptions.find(option => option.value === value);

export const getPersonInitials = (name: string): string =>
  name
    .split(" ")
    .map(n => n[0])
    .join("");
